import { getProviderKeyByType, getProviderKey } from '@noda-lib/assets/tools';
import { TUI_ENGLISH_LANGUAGE, TUI_LANGUAGE } from '@taiga-ui/i18n';
import { of } from 'rxjs';
import { InjectionToken } from '@angular/core';
import { replaceTags } from '@noda-lib/utils/handlers';
const englishLangOverrides = {
  inputFileTexts: {
    formatRejectionReason: 'Wrong file format. Supported formats: PDF, JPG, JPEG, DOC, DOCX, PNG, SVG, ZIP or CSV',
    maxSizeRejectionReason: 'File too large. Size must be under'
  }
};
function defaultLocalizeFn(value, params) {
  return replaceTags(value, params);
}
const ASSETS_LANG = new InjectionToken('ASSETS_LANG', {
  factory() {
    return 'en';
  }
});
const ASSETS_LOCALIZE_FN = new InjectionToken('ASSETS_LOCALIZE_FN', {
  factory() {
    return defaultLocalizeFn;
  }
});
const TUI_ENGLISH_LANGUAGE_CUSTOMIZED = {
  name: 'english',
  ...TUI_ENGLISH_LANGUAGE,
  inputFileTexts: {
    ...TUI_ENGLISH_LANGUAGE.inputFileTexts,
    ...englishLangOverrides.inputFileTexts
  }
};
function withLocalizeFn(fn, type = 'value') {
  const providerKey = getProviderKeyByType(type);
  return [{
    provide: ASSETS_LOCALIZE_FN,
    [providerKey]: fn
  }];
}
function withLocalizeLanguage(lang) {
  const key = getProviderKey(lang);
  return [{
    provide: ASSETS_LANG,
    [key]: lang
  }];
}
function withUpdatedLang() {
  return [{
    provide: TUI_LANGUAGE,
    useValue: of(TUI_ENGLISH_LANGUAGE_CUSTOMIZED)
  }];
}

/**
 * Generated bundle index. Do not edit.
 */

export { ASSETS_LANG, ASSETS_LOCALIZE_FN, TUI_ENGLISH_LANGUAGE_CUSTOMIZED, withLocalizeFn, withLocalizeLanguage, withUpdatedLang };
